/* eslint-disable global-require, import/no-unresolved */

// This is a alias proxy, which will use global `dw-neit-cssinjs` first.
// Use local if global not found.
let cssinjs;

if (typeof window !== 'undefined' && window.antdCssinjs) {
  // Use window UMD version
  cssinjs = window.antdCssinjs;
} else if (typeof global !== 'undefined' && global.antdCssinjs) {
  // Use global UMD version
  cssinjs = global.antdCssinjs;
} else {
  // Use local version.
  // Use relative path since webpack will also replace module here.
  cssinjs = require('../node_modules/dw-neit-cssinjs');
}

module.exports = cssinjs;
